<ion-content class="component-container">
  <ion-header class="component-header ion-no-border">
    <ion-toolbar>
      <ion-buttons slot="start" class="">
        <ion-title class="ion-no-padding component-title">Leads</ion-title>
        <ng-container *ngIf="gridViewComponent?.areRowsSelected()">
          <ion-button class="unfilled-red-btn-sm ms-2"  (click)="deleteMultipleRow()">Delete</ion-button>
          <ion-button class="unfilled-blue-btn btn-sm ms-0" (click)="openCommonFieldsForm($event)">More</ion-button>
        </ng-container>
      </ion-buttons>

      <ion-buttons *ngIf="leadFilterStatusLov">
        <div class="status-filters-main-container">
          <button class="status-filter-btn" style="--status-color: #000" (click)="toggleAllStatusFilters()" [ngClass]="{'active': isAllStatusFiltersActive()}">All</button>
          <button class="status-filter-btn" style="--status-color: #00388C" (click)="toggleStatusFilter(RECORD_STATUS_VALUES.NEW)" [ngClass]="{'active': checkIfStatusActive(RECORD_STATUS_VALUES.NEW)}">New <span class="count">{{getStatusCount('New')}}</span></button>
          <button class="status-filter-btn" style="--status-color: #06A781" (click)="toggleStatusFilter(RECORD_STATUS_VALUES.CONVERTED)" [ngClass]="{'active': checkIfStatusActive(RECORD_STATUS_VALUES.CONVERTED)}">Converted <span class="count">{{getStatusCount('Converted')}}</span></button>
          <button class="status-filter-btn" style="--status-color: #006822" (click)="toggleStatusFilter(RECORD_STATUS_VALUES.CONTACTED)" [ngClass]="{'active': checkIfStatusActive(RECORD_STATUS_VALUES.CONTACTED)}">Contacted <span class="count">{{getStatusCount('Contacted')}}</span></button>
          <button class="status-filter-btn" style="--status-color: #8D5C00" (click)="toggleStatusFilter(RECORD_STATUS_VALUES.IN_PROGRESS)" [ngClass]="{'active': checkIfStatusActive(RECORD_STATUS_VALUES.IN_PROGRESS)}">In Progress <span class="count">{{getStatusCount('In Progress')}}</span></button>
          <button class="status-filter-btn" style="--status-color: #6312C7" (click)="toggleStatusFilter(RECORD_STATUS_VALUES.TRIP_COMPLETED)" [ngClass]="{'active': checkIfStatusActive(RECORD_STATUS_VALUES.TRIP_COMPLETED)}">Trip Completed <span class="count">{{getStatusCount('Trip Completed')}}</span></button>
          <button class="status-filter-btn" style="--status-color: #AF3510" (click)="toggleStatusFilter(RECORD_STATUS_VALUES.ON_HOLD)" [ngClass]="{'active': checkIfStatusActive(RECORD_STATUS_VALUES.ON_HOLD)}">On Hold <span class="count">{{getStatusCount('On Hold')}}</span></button>
          <div class="more-status-main-container">
            <button class="more-status-btn" (click)="openMoreStatusDropdown($event)">More <span>▼</span></button>
          </div>
        </div>
      </ion-buttons>      

      <ion-buttons slot="end" class="">
        <ion-button class="unfilled-gray-btn" (click)="toggleFilters()">
          <div class="heder-end-button">
            <ion-icon name="funnel-outline"></ion-icon>
          </div>
        </ion-button>
        <ion-button *ngIf="showLeadButton" class="filled-blue-btn"
          id="open-custom-dialog" (click)="openNewLeadForm()">
          <div class="heder-end-button">
            <ion-icon name="add-outline"></ion-icon>
            <ion-text>Add Lead</ion-text>
          </div>
        </ion-button>
        <ion-button class="filled-blue-btn" (click)="downloadLeadsCSV()" *ngIf="originalLeadList?.length > 0">
          <div class="heder-end-button">
            <ion-icon name="download-outline"></ion-icon>
          </div>
        </ion-button>
        <ion-button class="filled-blue-btn" (click)="bulkUploadLeads()">
          <div class="heder-end-button">
            <ion-icon name="cloud-upload-outline"></ion-icon>
          </div>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>

  <div class="filter-main-container" *ngIf="showFilters">
    <div>
      <ion-buttons slot="start" class="filters-main-container">
        <ion-button *ngIf="organizationType == ORGANIZATION_TYPES.AGENT_AND_DMC" class="filter-btn" [ngClass]="{'filter-applied': leadFilters?.type?.length}"
          (click)="openFiltersPopup($event, 'name', 'type', 'type')">
          <ion-text class="me-1">Lead Type</ion-text>
          <ion-text *ngIf="leadFilters?.type?.length">(+{{leadFilters?.type?.length}})</ion-text>
          <ion-icon name="caret-down-outline"></ion-icon>
        </ion-button>

        <ion-button class="filter-btn" [ngClass]="{'filter-applied': leadFilters?.ownership?.length}"
          (click)="openFiltersPopup($event, 'name', ENTITY_NAMES.USER, 'ownership')">
          <ion-text class="me-1">Assigned To</ion-text>
          <ion-text *ngIf="leadFilters?.ownership?.length">(+{{leadFilters?.ownership?.length}})</ion-text>
          <ion-icon name="caret-down-outline"></ion-icon>
        </ion-button>

        <ion-button class="filter-btn" [ngClass]="{'filter-applied': leadFilters?.travelServices.length}"
          (click)="openFiltersPopup($event, 'name', ENTITY_NAMES.TRAVEL_SERVICES, 'travelServices')">
          <ion-text class="me-1">Service Type</ion-text>
          <ion-text *ngIf="leadFilters?.travelServices?.length">(+{{leadFilters?.travelServices?.length}})</ion-text>
          <ion-icon name="caret-down-outline"></ion-icon>
        </ion-button>

        <ion-button class="filter-btn" [ngClass]="{'filter-applied': leadFilters?.priority?.length}"
          (click)="openFiltersPopup($event, 'name', ENTITY_NAMES.TASK_PRIORITY, 'priority')">
          <ion-text class="me-1">Priority</ion-text>
          <ion-text *ngIf="leadFilters?.priority?.length">(+{{leadFilters?.priority?.length}})</ion-text>
          <ion-icon name="caret-down-outline"></ion-icon>
        </ion-button>

        <ion-button class="filter-btn" [ngClass]="{'filter-applied': leadFilters?.source?.length}"
          (click)="openFiltersPopup($event, 'name', ENTITY_NAMES.LEAD_SOURCE, 'source')">
          <ion-text class="me-1">Source</ion-text>
          <ion-text *ngIf="leadFilters?.source?.length">(+{{leadFilters?.source?.length}})</ion-text>
          <ion-icon name="caret-down-outline"></ion-icon>
        </ion-button>

        <ion-button class="filter-btn" [ngClass]="{'filter-applied': leadFilters?.createdBy?.length}"
          (click)="openFiltersPopup($event, 'createdBy', ENTITY_NAMES.USER, 'createdBy')">
          <ion-text class="me-1">Created By</ion-text>
          <ion-text *ngIf="leadFilters?.createdBy?.length">(+{{leadFilters?.createdBy?.length}})</ion-text>
          <ion-icon name="caret-down-outline"></ion-icon>
        </ion-button>

        <div>
          <!-- TODO: use date picker here -->
          <input class="date-filter" type="date" [(ngModel)]="fromDate" [max]="today" (ngModelChange)="onFromDateChange($event)">
          <!-- <app-date-picker class="filter" type="date" [(ngModel)]="fromDate" [maxDate]="today" (ngModelChange)="onFromDateChange($event)"></app-date-picker> -->
        </div>

        <div>
          <label for="" class="label px-1">To</label>
        </div>

        <div>
          <input class="date-filter" type="date" [(ngModel)]="toDate" [disabled]="!fromDate" [min]="fromDate" [max]="today" (ngModelChange)="onToDateChange($event)">
        </div>

        <ion-button class="unfilled-red-btn btn-sm" (click)="clearFilters()">
          <ion-text>Clear Filters</ion-text>
        </ion-button>
      </ion-buttons>
    </div>
  </div>
  <div class="p-1 w-100 overflow-auto component-content" *ngIf="allLeadsData">
    <app-grid-view 
    [allData]="allLeadsData" 
    [columns]="allLeadsDataColumns" 
    [showColumnSelector]="true" 
    (manageColumnsChange)="manageColumnsChanged($event)"
    [optionsValues]="leadOptionsValues" 
    [showStatusDropdown]="true" 
    (triggerStatusChange)="leadStatusChanged($event)"
    (triggerDeleteRow)="deleteLeadRow($event)" 
    (triggerEditRow)="editLeadOpen($event)"
    (triggerViewRow)="viewLead($event)" 
    (triggerTaskRow)="createTaskForLead($event)"
    (paginationsUpdated)="updatePagination($event)" 
    (triggerAduitHistoryRow)="showAuditHistory($event)"
    (emitRowOnCellClicked)="gridCellClicked($event)" 
    [columnsToFreeze]="2"
    [multiSelectProperty]="'leadId'"
    [showWhatsappActionBtn]="true"
    [showEmailActionBtn]="true"
    (emitWhatsappActionTrigger)="openLeadWhatsappNumber($event)"
    (emitEmailActionTrigger)="openLeadEmail($event)"
    (emitCallActionTrigger)="sendCallNotification($event)"
    ></app-grid-view>
  </div>

</ion-content>
